module.exports = __webpack_public_path__ + "assets/images/vvB9eDfs.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down.svg
// module id = 1133
// module chunks = 0